export default "__VITE_ASSET__DMywDWgz__"